import React from "react";
import { Grid, Cell, Button } from "react-md";
import { createEmptyVectorAnswerFormula } from "./VariablesTable";
import VectorAnswerFormula from "./VectorAnswerFormula";

const VectorAnswers = ({ _vectorAnswers, onValueChange, vectorVariablesMap }) => {

  const onAddVector = () => {
    const index = _vectorAnswers.length;
    onValueChange([..._vectorAnswers, createEmptyVectorAnswerFormula(index)]);
  };

  const onVectorValueChange = (value, targetIndex) => {
    let updatedVector = {...value};
    if (!updatedVector.autoOrigin) {
        updatedVector.posX = updatedVector.xOrigin;
        updatedVector.posY = updatedVector.yOrigin;
    }
    const tempVector = _vectorAnswers.map((_vector, index) => {
      if (index === targetIndex) {
        return updatedVector;
      } else {
        return { ..._vector };
      }
    });

    onValueChange([...tempVector]);
  };

  const onDelete = (index) => {
    onValueChange([
      ..._vectorAnswers.slice(0, index),
      ..._vectorAnswers.slice(index + 1),
    ]);
  };
  if (_vectorAnswers) {
    return (
      <Grid>
        <Cell size={12}>
          <Button flat primary swapTheming onClick={onAddVector}>
             Add Vector Answer
          </Button>
        </Cell>
        {_vectorAnswers.map((vector, index) => {
          return (
            <Cell key={index} size={12}>
              <div style={{ textAlign: "right", paddingBottom: "1em" }}>
                <Button
                  flat
                  primary
                  swapTheming
                  onClick={() => onDelete(index)}
                >
                  Delete Vector Answer
                </Button>
              </div>
              <VectorAnswerFormula
                data={{
                  ...vector,
                }}
                vectorVariablesMap={vectorVariablesMap}
                onValueChange={(value) => {
                  onVectorValueChange(value, index);
                }}
              />
            </Cell>
          );
        })}
      </Grid>
    );
  } else {
    return null;
  }
};

export default VectorAnswers;
